import type { ComponentSchema } from "../../../../../schema-types";
import { SECTION_STYLE_FIELDS } from "../../_builder-constants";

const PRODUCT_SCHEMA = [
  { key: "id", label: "Product ID", type: "string" as const },
  { key: "name", label: "Product Name", type: "string" as const },
  { key: "image", label: "Image", type: "image" as const },
  { key: "price", label: "Price", type: "number" as const },
  { key: "originalPrice", label: "Original Price", type: "number" as const },
  { key: "badge", label: "Badge Text", type: "string" as const },
];

export const schema: ComponentSchema = {
  type: "new-arrivals",
  label: "New Arrivals",
  description: "A grid of the newest products: square photos, six across, with name and price.",
  supportedPages: ["home"],
  variants: [
    {
      id: "v1",
      label: "Photo grid",
      fields: [
        { key: "title", label: "Section Title", type: "string", default: "New Arrivals" },
        { key: "subtitle", label: "Subtitle", type: "string", default: "Fresh styles just landed" },
        { key: "products", label: "Products", type: "array", itemSchema: PRODUCT_SCHEMA },
        { key: "limit", label: "Products shown", type: "number", default: 12, help: "Six fill one row on desktop." },
        { key: "showDetails", label: "Show name and price", type: "boolean", default: true },
      ],
    },
  ],
  commonFields: [...SECTION_STYLE_FIELDS],
};
